// extracted by mini-css-extract-plugin
export default {"container":"PlayerWrapper_container__fDuuQ"};